(function () {
  var CONSENT_KEY = 'fnd_cookie_consent';
  var GTM_ID = 'GTM-P4TQQLK';
  var META_PIXEL_ID = '1442833529990000';

  function loadGTM() {
    if (window.__fndGtmLoaded) return;
    window.__fndGtmLoaded = true;
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', GTM_ID);
  }

  function loadMetaPixel() {
    if (window.__fndMetaPixelLoaded) return;
    window.__fndMetaPixelLoaded = true;
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }

  function grantConsent() {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
    }
    loadGTM();
    loadMetaPixel();
  }

  function getStoredConsent() {
    try {
      return window.localStorage.getItem(CONSENT_KEY);
    } catch (e) {
      return null;
    }
  }

  function storeConsent(value) {
    try {
      window.localStorage.setItem(CONSENT_KEY, value);
    } catch (e) {}
  }

  // Exposes the banner's current rendered height as --fnd-cookie-banner-height,
  // so other fixed bottom UI (e.g. the Intercom launcher) can stay clear of it
  // for as long as it's showing, on any screen size.
  function trackBannerHeight(banner) {
    function update() {
      var height = banner.hasAttribute('hidden') ? 0 : banner.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--fnd-cookie-banner-height', height + 'px');
    }

    update();
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(banner);
    } else {
      window.addEventListener('resize', update);
    }
    new MutationObserver(update).observe(banner, { attributes: true, attributeFilter: ['hidden'] });
  }

  function init() {
    var stored = getStoredConsent();

    if (stored === 'granted') {
      grantConsent();
      return;
    }
    if (stored === 'denied') {
      return;
    }

    var banner = document.getElementById('CookieConsentBanner');
    if (!banner) return;
    banner.removeAttribute('hidden');
    trackBannerHeight(banner);

    var acceptBtn = banner.querySelector('[data-cookie-consent-accept]');
    var declineBtn = banner.querySelector('[data-cookie-consent-decline]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        storeConsent('granted');
        grantConsent();
        banner.setAttribute('hidden', 'hidden');
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        storeConsent('denied');
        banner.setAttribute('hidden', 'hidden');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
